import ReviewRatings from '../../components/review-ratings/review-ratings';
import useTranslation from '../../hooks/use-translation/use-translation';
import Accordion from '../collapsible/collapsible';
import Rating from '../rating/rating';

const ProductArtistReviews = ({artist}) => {
  const {t} = useTranslation();
  const data = artist.review_data;

  return (
    <Accordion
      label={
        <>
          {t('Artist Reviews')} <Rating value={data.seller_rating} size="18px" />{' '}
          <span>({data.review_count})</span>
        </>
      }
    >
      <ReviewRatings
        value={data.seller_rating}
        count={data.review_count}
        starRatings={data.seller_rating_breakdown}
        readAllUrl={`/artist/${artist.slug}/reviews/`}
      />
    </Accordion>
  );
};

export default ProductArtistReviews;
